<div class="a-upload-area-container" ng2FileDrop (fileOver)="onFileOver($event)"
    [ngClass]="{'a-upload-area_over':hasDropzoneOver}" [uploader]="uploader">
    <ng-container *ngIf="content!=null">
        <ng-template [ngTemplateOutlet]="content"
            [ngTemplateOutletContext]="{$implicit:uploader,selectBtn:fileSelectTmp }">
        </ng-template>
    </ng-container>
    <ng-container *ngIf="content==null && displaySelectBtn">
        <ng-template [ngTemplateOutlet]="fileSelectTmp"></ng-template>
    </ng-container>
</div>

<ng-template #fileSelectTmp>
    <div class="a-upload-area-select-button">
        <ng-container *ngIf="multiple">
            <input type="file" style="display: none;" #fileSelect ng2FileSelect class="btn btn-primary" accept="{{allowedMimeTypes?.join(',')}}"
                [uploader]="uploader" multiple />
            <button class="btn btn-primary" type="button" (click)="fileSelect.click()">{{selectBtnText}}</button>
        </ng-container>
        <ng-container *ngIf="!multiple">
            <input type="file" style="display: none;" #fileSelect ng2FileSelect class="btn btn-primary" accept="{{allowedMimeTypes?.join(',')}}"
                [uploader]="uploader" />
            <button class="btn btn-primary" type="button" (click)="fileSelect.click()">{{selectBtnText}}</button>
        </ng-container>
    </div>
</ng-template>